package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.eladfinish.bible.contest.ui.utils.MyBackHandler

fun interface SystemButtonsConfigurator {
    fun onBackPressed()
}

val LocalSystemButtonsConfigurator: ProvidableCompositionLocal<SystemButtonsConfigurator?> =
    compositionLocalOf { null }

@Composable
fun SetSystemBackButtonEnabled(isEnabled: Boolean) {
    val configurator = LocalSystemButtonsConfigurator.current

    MyBackHandler(enabled = isEnabled) {
        configurator?.onBackPressed()
    }
}
